const castArrayOfPropsToQueryObject = (accessor: string, array: string[]) => {
    const clientIdsObject =
        array && array.length > 0
            ? array.reduce((obj: any, id, index) => {
                  obj[`${accessor}[${index}]`] = id;
                  return obj;
              }, {})
            : undefined;
    return clientIdsObject;
};

const castObjectToArrayOfIds = (obj: any) => {
    const arrayOfObj = Object.keys(obj).map((key) => obj[key]);
    return arrayOfObj;
};

const extractQueryArrayValues = (accessor: string, queryParamsGetter: (key: string) => string | null) => {
    let index = 0;
    const resultArray = [];

    let value = queryParamsGetter(`${accessor}[${index}]`);

    while (value) {
        resultArray.push(value);
        index++;
        value = queryParamsGetter(`${accessor}[${index}]`);
    }

    return resultArray;
};

export { castArrayOfPropsToQueryObject, castObjectToArrayOfIds, extractQueryArrayValues };
